module.exports = __webpack_public_path__ + "img/民乐报.8f516444.png";